/**
 * This module check the initial value of the postal code and if any changes has been made. It will check on submit and push the measurement to GTM.
 * This module should be set on the FORM that contains the postal code
 * [data-postal-code-measurement] = this attribute should be set on the FORM and contains the measurement in JSON format.
 * [data-postal-code-input] = this attribute must be set on the input with postal code containing the initial value which it should compare with any changes.
 */
class HandleMeasurementOnPostalCodeChange {
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._init();
    }

    _init() {
        this._setInitialProps();
        this._bindEvents();
    }


    _setInitialProps() {
        this._input = this._element.querySelector('[data-postal-code-input]');
        this._initialValue = this._input.value;
        this._measurement = JSON.parse(this._options.postalCodeMeasurement);
    }

    _bindEvents() {
        this._element.addEventListener('submit', this._handleSubmit.bind(this));
    }

    _handleSubmit() {
        const input = this._input;
        const value = input.value;
        const initialValue = this._initialValue;
        const isValid = !input.classList.contains('error');
        const hasChanged = initialValue !== value;

        if(isValid && hasChanged) {
            this._handleChangeInPostalCode();
        }
    }

    _handleChangeInPostalCode() {
        const measurement = this._measurement;

        this._pushMeasurement(measurement);
    }

    _pushMeasurement(measurement) {
        if(window.dataLayer) {
            window.dataLayer.push(measurement)
        }
    }
}
